import React, { useState, useEffect, useMemo } from 'react';
import {
    Widget,
    GridView,
    SimpleView,
    Table,
    ColumnProps,
    FormSelect,
    Form,
    Row,
    FormInput,
    Col,
    Button,
    FormResetButton,
} from '@digital/ui';
import { CtrPcsResultData } from '../../api/ctrPcs';
import { getAllPedidoFornecedorFake, getAllPedidoFornecedorFakeCrf } from '@app/api/manutencaoPcmFornecedorController';
import { FornecedorResult, getAllFornecedorResult } from '@app/api/fornecedor';
import ModalFornecedor from './modalFornecedor';
import { compareText, compareTypeNumber } from '@app/helpers/comparators';
import { Icon, Tooltip, Collapse } from 'antd';

const { Panel } = Collapse
interface ManutencaoPcmFornecedorProps {

}


const ManutencaoPcmFornecedor = (props: ManutencaoPcmFornecedorProps) => {
    const [resultPesquisa, setResultConsult] = useState<CtrPcsResultData[]>([]);
    const [resultPesquisaCrf, setResultConsultCrf] = useState<CtrPcsResultData[]>([]);
    const [resultFornecedorResult, setResultFornecedorResult] = useState<FornecedorResult[]>([]);

    useEffect(() => {

        atualizarTabelaResult();

        getAllFornecedorResult().then((data) => {
            if (data)
                setResultFornecedorResult(data);
        })

    }, []);

    const atualizarTabelaResult = () => {
        getAllPedidoFornecedorFake().then((data) => {
            if (data)
                setResultConsult(data)
        });

        getAllPedidoFornecedorFakeCrf().then((data) => {
            if (data)
                setResultConsultCrf(data)
        });
    }

    const columsRequisicaoCompraSeq: ColumnProps<any>[] = [
        {
            title: 'PACOTE /OI',
            key: 'pacoteOi',
            children: [
                {
                    title: 'N',
                    dataIndex: 'row',
                    width: '1%',
                },
                {
                    title: 'Código',
                    dataIndex: 'pacoteOiCodigo',
                    width: '',
                    sorter: (a, b) => compareText(a.pacoteOiCodigo, b.pacoteOiCodigo),
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <Form>
                            <Row>
                                <FormInput
                                    placeholder="Pesquisar"
                                    name="pacoteOiCodigo"
                                    style={{ marginTop: '15px' }}
                                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                    onPressEnter={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                />
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => {
                                            if (typeof confirm === 'function') confirm();
                                        }}
                                        icon="commons-search"
                                        size="small">
                                        Pesquisar
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <FormResetButton
                                        size="small"
                                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                        beforeReset={() => {
                                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                        }}>
                                        Limpar
                                    </FormResetButton>
                                </Col>
                            </Row>
                        </Form>
                    ),
                    filterIcon: filtered => {
                        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                    },
                    onFilter: (value, record) =>
                        record.pacoteOiCodigo !== undefined &&
                        record.pacoteOiCodigo
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                },
                {
                    title: 'Nome',
                    dataIndex: 'pacoteOiNome',
                    width: '',
                    sorter: (a, b) => compareText(a.pacoteOiNome, b.pacoteOiNome),
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <Form>
                            <Row>
                                <FormInput
                                    placeholder="Pesquisar"
                                    name="pacoteOiNome"
                                    style={{ marginTop: '15px' }}
                                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                    onPressEnter={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                />
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => {
                                            if (typeof confirm === 'function') confirm();
                                        }}
                                        icon="commons-search"
                                        size="small">
                                        Pesquisar
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <FormResetButton
                                        size="small"
                                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                        beforeReset={() => {
                                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                        }}>
                                        Limpar
                                    </FormResetButton>
                                </Col>
                            </Row>
                        </Form>
                    ),
                    filterIcon: filtered => {
                        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                    },
                    onFilter: (value, record) =>
                        record.pacoteOiNome !== undefined &&
                        record.pacoteOiNome
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                },
                {
                    title: 'OI',
                    dataIndex: 'pacoteOiOi',
                    width: '',
                    sorter: (a, b) => compareText(a.pacoteOiOi, b.pacoteOiOi),
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <Form>
                            <Row>
                                <FormInput
                                    placeholder="Pesquisar"
                                    name="pacoteOiOi"
                                    style={{ marginTop: '15px' }}
                                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                    onPressEnter={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                />
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => {
                                            if (typeof confirm === 'function') confirm();
                                        }}
                                        icon="commons-search"
                                        size="small">
                                        Pesquisar
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <FormResetButton
                                        size="small"
                                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                        beforeReset={() => {
                                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                        }}>
                                        Limpar
                                    </FormResetButton>
                                </Col>
                            </Row>
                        </Form>
                    ),
                    filterIcon: filtered => {
                        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                    },
                    onFilter: (value, record) =>
                        record.pacoteOiOi !== undefined &&
                        record.pacoteOiOi
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                },
                {
                    title: 'PROJETO',
                    dataIndex: 'pacoteOiProjeto',
                    width: '',
                    sorter: (a, b) => compareText(a.pacoteOiProjeto, b.pacoteOiProjeto),
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <Form>
                            <Row>
                                <FormInput
                                    placeholder="Pesquisar"
                                    name="pacoteOiProjeto"
                                    style={{ marginTop: '15px' }}
                                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                    onPressEnter={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                />
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => {
                                            if (typeof confirm === 'function') confirm();
                                        }}
                                        icon="commons-search"
                                        size="small">
                                        Pesquisar
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <FormResetButton
                                        size="small"
                                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                        beforeReset={() => {
                                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                        }}>
                                        Limpar
                                    </FormResetButton>
                                </Col>
                            </Row>
                        </Form>
                    ),
                    filterIcon: filtered => {
                        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                    },
                    onFilter: (value, record) =>
                        record.pacoteOiProjeto !== undefined &&
                        record.pacoteOiProjeto
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                },
            ],
        },
        {
            title: 'RC',
            key: 'rc',
            children: [
                {
                    title: 'NÚMERO	',
                    dataIndex: 'rcNumero',
                    width: '',
                    sorter: (a, b) => compareTypeNumber(a.rcNumero, b.rcNumero),
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <Form>
                            <Row>
                                <FormInput
                                    placeholder="Pesquisar"
                                    name="rcNumero"
                                    style={{ marginTop: '15px' }}
                                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                    onPressEnter={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                />
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => {
                                            if (typeof confirm === 'function') confirm();
                                        }}
                                        icon="commons-search"
                                        size="small">
                                        Pesquisar
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <FormResetButton
                                        size="small"
                                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                        beforeReset={() => {
                                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                        }}>
                                        Limpar
                                    </FormResetButton>
                                </Col>
                            </Row>
                        </Form>
                    ),
                    filterIcon: filtered => {
                        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                    },
                    onFilter: (value, record) =>
                        record.rcNumero !== undefined &&
                        record.rcNumero
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                },
                {
                    title: 'SEQ',
                    dataIndex: 'rcSeq',
                    width: '',
                    sorter: (a, b) => compareTypeNumber(a.rcSeq, b.rcSeq),
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <Form>
                            <Row>
                                <FormInput
                                    placeholder="Pesquisar"
                                    name="rcSeq"
                                    style={{ marginTop: '15px' }}
                                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                    onPressEnter={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                />
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => {
                                            if (typeof confirm === 'function') confirm();
                                        }}
                                        icon="commons-search"
                                        size="small">
                                        Pesquisar
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <FormResetButton
                                        size="small"
                                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                        beforeReset={() => {
                                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                        }}>
                                        Limpar
                                    </FormResetButton>
                                </Col>
                            </Row>
                        </Form>
                    ),
                    filterIcon: filtered => {
                        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                    },
                    onFilter: (value, record) =>
                        record.rcSeq !== undefined &&
                        record.rcSeq
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                },
                {
                    title: 'STATUS',
                    dataIndex: 'rcStatus',
                    width: '',
                    sorter: (a, b) => compareText(a.rcStatus, b.rcStatus),
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <Form>
                            <Row>
                                <FormInput
                                    placeholder="Pesquisar"
                                    name="rcStatus"
                                    style={{ marginTop: '15px' }}
                                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                    onPressEnter={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                />
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => {
                                            if (typeof confirm === 'function') confirm();
                                        }}
                                        icon="commons-search"
                                        size="small">
                                        Pesquisar
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <FormResetButton
                                        size="small"
                                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                        beforeReset={() => {
                                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                        }}>
                                        Limpar
                                    </FormResetButton>
                                </Col>
                            </Row>
                        </Form>
                    ),
                    filterIcon: filtered => {
                        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                    },
                    onFilter: (value, record) =>
                        record.rcStatus !== undefined &&
                        record.rcStatus
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                },
            ],
        },
        {
            title: 'OC',
            key: 'oc',
            children: [
                {
                    title: 'Numero',
                    dataIndex: 'ocNumero',
                    width: '',
                    sorter: (a, b) => compareTypeNumber(a.ocNumero, b.ocNumero),
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <Form>
                            <Row>
                                <FormInput
                                    placeholder="Pesquisar"
                                    name="ocNumero"
                                    style={{ marginTop: '15px' }}
                                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                    onPressEnter={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                />
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => {
                                            if (typeof confirm === 'function') confirm();
                                        }}
                                        icon="commons-search"
                                        size="small">
                                        Pesquisar
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <FormResetButton
                                        size="small"
                                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                        beforeReset={() => {
                                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                        }}>
                                        Limpar
                                    </FormResetButton>
                                </Col>
                            </Row>
                        </Form>
                    ),
                    filterIcon: filtered => {
                        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                    },
                    onFilter: (value, record) =>
                        record.ocNumero !== undefined &&
                        record.ocNumero
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                },
                {
                    title: 'Data',
                    dataIndex: 'ocData',
                    width: '',
                    sorter: (a, b) => compareText(a.ocData, b.ocData),
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <Form>
                            <Row>
                                <FormInput
                                    placeholder="Pesquisar"
                                    name="ocData"
                                    style={{ marginTop: '15px' }}
                                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                    onPressEnter={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                />
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => {
                                            if (typeof confirm === 'function') confirm();
                                        }}
                                        icon="commons-search"
                                        size="small">
                                        Pesquisar
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <FormResetButton
                                        size="small"
                                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                        beforeReset={() => {
                                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                        }}>
                                        Limpar
                                    </FormResetButton>
                                </Col>
                            </Row>
                        </Form>
                    ),
                    filterIcon: filtered => {
                        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                    },
                    onFilter: (value, record) =>
                        record.ocData !== undefined &&
                        record.ocData
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                },
            ],
        },
        {
            title: 'PEDIDO',
            key: 'PEDIDO',
            children: [
                {
                    title: 'PCM',
                    dataIndex: 'pedidoPcm',
                    sorter: (a, b) => compareTypeNumber(a.pedidoPcm, b.pedidoPcm),
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <Form>
                            <Row>
                                <FormInput
                                    placeholder="Pesquisar"
                                    name="pedidoPcm"
                                    style={{ marginTop: '15px' }}
                                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                    onPressEnter={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                />
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => {
                                            if (typeof confirm === 'function') confirm();
                                        }}
                                        icon="commons-search"
                                        size="small">
                                        Pesquisar
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <FormResetButton
                                        size="small"
                                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                        beforeReset={() => {
                                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                        }}>
                                        Limpar
                                    </FormResetButton>
                                </Col>
                            </Row>
                        </Form>
                    ),
                    filterIcon: filtered => {
                        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                    },
                    onFilter: (value, record) =>
                        record.pedidoPcm !== undefined &&
                        record.pedidoPcm
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                },
                {
                    title: 'TIPO',
                    dataIndex: 'pedidoTipo',
                    sorter: (a, b) => compareText(a.pedidoTipo, b.pedidoTipo),
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <Form>
                            <Row>
                                <FormInput
                                    placeholder="Pesquisar"
                                    name="pedidoTipo"
                                    style={{ marginTop: '15px' }}
                                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                    onPressEnter={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                />
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => {
                                            if (typeof confirm === 'function') confirm();
                                        }}
                                        icon="commons-search"
                                        size="small">
                                        Pesquisar
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <FormResetButton
                                        size="small"
                                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                        beforeReset={() => {
                                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                        }}>
                                        Limpar
                                    </FormResetButton>
                                </Col>
                            </Row>
                        </Form>
                    ),
                    filterIcon: filtered => {
                        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                    },
                    onFilter: (value, record) =>
                        record.pedidoTipo !== undefined &&
                        record.pedidoTipo
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                },
                {
                    title: 'FORNECEDOR',
                    dataIndex: 'pedidoFornecedor',
                    sorter: (a, b) => compareText(a.pedidoFornecedor, b.pedidoFornecedor),
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <Form>
                            <Row>
                                <FormInput
                                    placeholder="Pesquisar"
                                    name="pedidoFornecedor"
                                    style={{ marginTop: '15px' }}
                                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                    onPressEnter={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                />
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => {
                                            if (typeof confirm === 'function') confirm();
                                        }}
                                        icon="commons-search"
                                        size="small">
                                        Pesquisar
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <FormResetButton
                                        size="small"
                                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                        beforeReset={() => {
                                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                        }}>
                                        Limpar
                                    </FormResetButton>
                                </Col>
                            </Row>
                        </Form>
                    ),
                    filterIcon: filtered => {
                        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                    },
                    onFilter: (value, record) =>
                        record.pedidoFornecedor !== undefined &&
                        record.pedidoFornecedor
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                },
                {
                    title: 'AÇÕES',
                    render: (text: any, record: CtrPcsResultData, index: number) => {
                        return [
                            <ModalFornecedor
                                fornecedoresResult={resultFornecedorResult}
                                pcmResult={record}
                                atualizarTabelaResult={atualizarTabelaResult}
                                crf={false}
                            />
                        ]
                    }
                }
            ],
        },
    ];

    const columsRequisicaoCompraSeqCrf: ColumnProps<any>[] = [
        {
            title: 'CC / CONTA CONTÁBIL',
            key: 'pacoteCodigo',
            children: [
                {
                    title: 'N',
                    dataIndex: 'row',
                    width: '1%',
                },
                {
                    title: 'Centro de Custo',
                    dataIndex: 'projetoNumero',
                    width: '',
                    sorter: (a, b) => compareText(a.projetoNumero, b.projetoNumero),
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <Form>
                            <Row>
                                <FormInput
                                    placeholder="Pesquisar"
                                    name="projetoNumero"
                                    style={{ marginTop: '15px' }}
                                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                    onPressEnter={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                />
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => {
                                            if (typeof confirm === 'function') confirm();
                                        }}
                                        icon="commons-search"
                                        size="small">
                                        Pesquisar
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <FormResetButton
                                        size="small"
                                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                        beforeReset={() => {
                                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                        }}>
                                        Limpar
                                    </FormResetButton>
                                </Col>
                            </Row>
                        </Form>
                    ),
                    filterIcon: filtered => {
                        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                    },
                    onFilter: (value, record) =>
                        record.projetoNumero !== undefined &&
                        record.projetoNumero
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                },
                {
                    title: 'Conta Contábil',
                    dataIndex: 'contaContabilCodigo',
                    width: '',
                    sorter: (a, b) => compareText(a.contaContabilCodigo, b.contaContabilCodigo),
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <Form>
                            <Row>
                                <FormInput
                                    placeholder="Pesquisar"
                                    name="contaContabilCodigo"
                                    style={{ marginTop: '15px' }}
                                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                    onPressEnter={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                />
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => {
                                            if (typeof confirm === 'function') confirm();
                                        }}
                                        icon="commons-search"
                                        size="small">
                                        Pesquisar
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <FormResetButton
                                        size="small"
                                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                        beforeReset={() => {
                                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                        }}>
                                        Limpar
                                    </FormResetButton>
                                </Col>
                            </Row>
                        </Form>
                    ),
                    filterIcon: filtered => {
                        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                    },
                    onFilter: (value, record) =>
                        record.contaContabilCodigo !== undefined &&
                        record.contaContabilCodigo
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                },
                {
                    title: 'Título Conta Contábil',
                    dataIndex: 'contaContabilNome',
                    width: '',
                    sorter: (a, b) => compareText(a.contaContabilNome, b.contaContabilNome),
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <Form>
                            <Row>
                                <FormInput
                                    placeholder="Pesquisar"
                                    name="contaContabilNome"
                                    style={{ marginTop: '15px' }}
                                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                    onPressEnter={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                />
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => {
                                            if (typeof confirm === 'function') confirm();
                                        }}
                                        icon="commons-search"
                                        size="small">
                                        Pesquisar
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <FormResetButton
                                        size="small"
                                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                        beforeReset={() => {
                                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                        }}>
                                        Limpar
                                    </FormResetButton>
                                </Col>
                            </Row>
                        </Form>
                    ),
                    filterIcon: filtered => {
                        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                    },
                    onFilter: (value, record) =>
                        record.contaContabilNome !== undefined &&
                        record.contaContabilNome
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                },
                {
                    title: 'Agrupador',
                    dataIndex: 'agrupador',
                    width: '',
                    sorter: (a, b) => compareText(a.agrupador, b.agrupador),
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <Form>
                            <Row>
                                <FormInput
                                    placeholder="Pesquisar"
                                    name="agrupador"
                                    style={{ marginTop: '15px' }}
                                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                    onPressEnter={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                />
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => {
                                            if (typeof confirm === 'function') confirm();
                                        }}
                                        icon="commons-search"
                                        size="small">
                                        Pesquisar
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <FormResetButton
                                        size="small"
                                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                        beforeReset={() => {
                                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                        }}>
                                        Limpar
                                    </FormResetButton>
                                </Col>
                            </Row>
                        </Form>
                    ),
                    filterIcon: filtered => {
                        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                    },
                    onFilter: (value, record) =>
                        record.agrupador !== undefined &&
                        record.agrupador
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                },
                {
                    title: 'Projeto',
                    dataIndex: 'projetoNome',
                    width: '',
                    sorter: (a, b) => compareText(a.projetoNome, b.projetoNome),
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <Form>
                            <Row>
                                <FormInput
                                    placeholder="Pesquisar"
                                    name="projetoNome"
                                    style={{ marginTop: '15px' }}
                                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                    onPressEnter={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                />
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => {
                                            if (typeof confirm === 'function') confirm();
                                        }}
                                        icon="commons-search"
                                        size="small">
                                        Pesquisar
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <FormResetButton
                                        size="small"
                                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                        beforeReset={() => {
                                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                        }}>
                                        Limpar
                                    </FormResetButton>
                                </Col>
                            </Row>
                        </Form>
                    ),
                    filterIcon: filtered => {
                        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                    },
                    onFilter: (value, record) =>
                        record.projetoNome !== undefined &&
                        record.projetoNome
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                },
            ],
        },
        {
            title: 'RC',
            key: 'rc',
            children: [
                {
                    title: 'NÚMERO	',
                    dataIndex: 'rcNumero',
                    width: '',
                    sorter: (a, b) => compareTypeNumber(a.rcNumero, b.rcNumero),
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <Form>
                            <Row>
                                <FormInput
                                    placeholder="Pesquisar"
                                    name="rcNumero"
                                    style={{ marginTop: '15px' }}
                                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                    onPressEnter={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                />
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => {
                                            if (typeof confirm === 'function') confirm();
                                        }}
                                        icon="commons-search"
                                        size="small">
                                        Pesquisar
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <FormResetButton
                                        size="small"
                                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                        beforeReset={() => {
                                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                        }}>
                                        Limpar
                                    </FormResetButton>
                                </Col>
                            </Row>
                        </Form>
                    ),
                    filterIcon: filtered => {
                        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                    },
                    onFilter: (value, record) =>
                        record.rcNumero !== undefined &&
                        record.rcNumero
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                },
                {
                    title: 'SEQ',
                    dataIndex: 'rcSeq',
                    width: '',
                    sorter: (a, b) => compareTypeNumber(a.rcSeq, b.rcSeq),
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <Form>
                            <Row>
                                <FormInput
                                    placeholder="Pesquisar"
                                    name="rcSeq"
                                    style={{ marginTop: '15px' }}
                                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                    onPressEnter={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                />
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => {
                                            if (typeof confirm === 'function') confirm();
                                        }}
                                        icon="commons-search"
                                        size="small">
                                        Pesquisar
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <FormResetButton
                                        size="small"
                                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                        beforeReset={() => {
                                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                        }}>
                                        Limpar
                                    </FormResetButton>
                                </Col>
                            </Row>
                        </Form>
                    ),
                    filterIcon: filtered => {
                        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                    },
                    onFilter: (value, record) =>
                        record.rcSeq !== undefined &&
                        record.rcSeq
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                },
                {
                    title: 'STATUS',
                    dataIndex: 'rcStatus',
                    width: '',
                    sorter: (a, b) => compareText(a.rcStatus, b.rcStatus),
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <Form>
                            <Row>
                                <FormInput
                                    placeholder="Pesquisar"
                                    name="rcStatus"
                                    style={{ marginTop: '15px' }}
                                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                    onPressEnter={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                />
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => {
                                            if (typeof confirm === 'function') confirm();
                                        }}
                                        icon="commons-search"
                                        size="small">
                                        Pesquisar
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <FormResetButton
                                        size="small"
                                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                        beforeReset={() => {
                                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                        }}>
                                        Limpar
                                    </FormResetButton>
                                </Col>
                            </Row>
                        </Form>
                    ),
                    filterIcon: filtered => {
                        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                    },
                    onFilter: (value, record) =>
                        record.rcStatus !== undefined &&
                        record.rcStatus
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                },
            ],
        },
        {
            title: 'OC',
            key: 'oc',
            children: [
                {
                    title: 'Numero',
                    dataIndex: 'ocNumero',
                    width: '',
                    sorter: (a, b) => compareTypeNumber(a.ocNumero, b.ocNumero),
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <Form>
                            <Row>
                                <FormInput
                                    placeholder="Pesquisar"
                                    name="ocNumero"
                                    style={{ marginTop: '15px' }}
                                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                    onPressEnter={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                />
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => {
                                            if (typeof confirm === 'function') confirm();
                                        }}
                                        icon="commons-search"
                                        size="small">
                                        Pesquisar
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <FormResetButton
                                        size="small"
                                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                        beforeReset={() => {
                                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                        }}>
                                        Limpar
                                    </FormResetButton>
                                </Col>
                            </Row>
                        </Form>
                    ),
                    filterIcon: filtered => {
                        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                    },
                    onFilter: (value, record) =>
                        record.ocNumero !== undefined &&
                        record.ocNumero
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                },
                {
                    title: 'Data',
                    dataIndex: 'ocData',
                    width: '',
                    sorter: (a, b) => compareText(a.ocData, b.ocData),
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <Form>
                            <Row>
                                <FormInput
                                    placeholder="Pesquisar"
                                    name="ocData"
                                    style={{ marginTop: '15px' }}
                                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                    onPressEnter={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                />
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => {
                                            if (typeof confirm === 'function') confirm();
                                        }}
                                        icon="commons-search"
                                        size="small">
                                        Pesquisar
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <FormResetButton
                                        size="small"
                                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                        beforeReset={() => {
                                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                        }}>
                                        Limpar
                                    </FormResetButton>
                                </Col>
                            </Row>
                        </Form>
                    ),
                    filterIcon: filtered => {
                        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                    },
                    onFilter: (value, record) =>
                        record.ocData !== undefined &&
                        record.ocData
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                },
            ],
        },
        {
            title: 'PEDIDO',
            key: 'PEDIDO',
            children: [
                {
                    title: 'PCM',
                    dataIndex: 'pedidoPcm',
                    sorter: (a, b) => compareTypeNumber(a.pedidoPcm, b.pedidoPcm),
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <Form>
                            <Row>
                                <FormInput
                                    placeholder="Pesquisar"
                                    name="pedidoPcm"
                                    style={{ marginTop: '15px' }}
                                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                    onPressEnter={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                />
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => {
                                            if (typeof confirm === 'function') confirm();
                                        }}
                                        icon="commons-search"
                                        size="small">
                                        Pesquisar
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <FormResetButton
                                        size="small"
                                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                        beforeReset={() => {
                                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                        }}>
                                        Limpar
                                    </FormResetButton>
                                </Col>
                            </Row>
                        </Form>
                    ),
                    filterIcon: filtered => {
                        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                    },
                    onFilter: (value, record) =>
                        record.pedidoPcm !== undefined &&
                        record.pedidoPcm
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                },
                {
                    title: 'TIPO',
                    dataIndex: 'pedidoTipo',
                    sorter: (a, b) => compareText(a.pedidoTipo, b.pedidoTipo),
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <Form>
                            <Row>
                                <FormInput
                                    placeholder="Pesquisar"
                                    name="pedidoTipo"
                                    style={{ marginTop: '15px' }}
                                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                    onPressEnter={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                />
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => {
                                            if (typeof confirm === 'function') confirm();
                                        }}
                                        icon="commons-search"
                                        size="small">
                                        Pesquisar
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <FormResetButton
                                        size="small"
                                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                        beforeReset={() => {
                                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                        }}>
                                        Limpar
                                    </FormResetButton>
                                </Col>
                            </Row>
                        </Form>
                    ),
                    filterIcon: filtered => {
                        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                    },
                    onFilter: (value, record) =>
                        record.pedidoTipo !== undefined &&
                        record.pedidoTipo
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                },
                {
                    title: 'FORNECEDOR',
                    dataIndex: 'pedidoFornecedor',
                    sorter: (a, b) => compareText(a.pedidoFornecedor, b.pedidoFornecedor),
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <Form>
                            <Row>
                                <FormInput
                                    placeholder="Pesquisar"
                                    name="pedidoFornecedor"
                                    style={{ marginTop: '15px' }}
                                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                    onPressEnter={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                />
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => {
                                            if (typeof confirm === 'function') confirm();
                                        }}
                                        icon="commons-search"
                                        size="small">
                                        Pesquisar
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <FormResetButton
                                        size="small"
                                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                        beforeReset={() => {
                                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                        }}>
                                        Limpar
                                    </FormResetButton>
                                </Col>
                            </Row>
                        </Form>
                    ),
                    filterIcon: filtered => {
                        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                    },
                    onFilter: (value, record) =>
                        record.pedidoFornecedor !== undefined &&
                        record.pedidoFornecedor
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                },
                {
                    title: 'AÇÕES',
                    render: (text: any, record: CtrPcsResultData, index: number) => {
                        return [
                            <ModalFornecedor
                                fornecedoresResult={resultFornecedorResult}
                                pcmResult={record}
                                atualizarTabelaResult={atualizarTabelaResult}
                                crf={true}
                            />
                        ]
                    }
                }
            ],
        },
    ];
    return (
        <SimpleView>
            <GridView noform>

                <Collapse bordered={false} defaultActiveKey={['1']} expandIcon={() => <Icon type="arrows-right_4" />}>
                    <Panel key="1" header="INVESTIMENTOS" style={{ border: 0 }}>
                        <Widget
                            title=""
                            span={12}
                            actions={[]}>
                            <Table
                                columns={columsRequisicaoCompraSeq}
                                dataSource={resultPesquisa}
                                pagination={{
                                    pageSize: 20,
                                }}
                            />
                        </Widget>
                    </Panel>
                </Collapse>

                <Collapse bordered={false} defaultActiveKey={['2']} expandIcon={() => <Icon type="arrows-right_4" />}>
                    <Panel key="2" header="CONTA RESULTADO E FECHAMENTO DE MINA" style={{ border: 0 }}>
                        <Widget
                            title=""
                            span={12}
                            actions={[]}>
                            <Table
                                columns={columsRequisicaoCompraSeqCrf}
                                dataSource={resultPesquisaCrf}
                                pagination={{
                                    pageSize: 20,
                                }}
                            />
                        </Widget>
                    </Panel>
                </Collapse>
            </GridView>
        </SimpleView>
    );
};

export default ManutencaoPcmFornecedor;
